import React from "react";
import { FormikProps } from "formik";

import { useToggleAll } from "../../../../lib/hooks/useToggleAll";

import { GroupFormFields } from "../lib/useGroupFormik";
import { GroupWorkspaceTreeLevel } from "./GroupWorkspaceTreeLevel";
import { GroupWorkspaceFooterPicker } from "./GroupWorkspaceFooterPicker";
import { WorkspacePicker } from "../../../shared/WorkspacePicker/WorkspacePicker";
import { ToggleAllButton } from "../../../shared/ToggleAllButton/ToggleAllButton";

interface Props {
  closePicker: () => void;
  clearWorkspaces: () => void;
  formik: FormikProps<GroupFormFields>;
}

export const GroupWorkspacePicker = ({
  closePicker,
  formik,
  clearWorkspaces,
}: Props) => {
  const { allToggled, handleToggleAll } = useToggleAll();

  return (
    <WorkspacePicker
      message="Select rooms and desks for this group"
      description="Pick rooms and desks for group access"
      closePicker={closePicker}
      title="Select workspace items"
      footer={
        <GroupWorkspaceFooterPicker
          desksCounter={formik.values.desks.length}
          roomsCounter={formik.values.rooms.length}
          clearWorkspaces={clearWorkspaces}
          handleConfirm={closePicker}
        />
      }
    >
      {({ rootWorkplaces }) => {
        return (
          <>
            <ToggleAllButton
              allToggled={allToggled}
              onToggleAll={handleToggleAll}
            />

            {rootWorkplaces.map((item) => {
              if (typeof item !== "object") {
                return null;
              }

              return item
                .filter((workplace) => workplace.__typename !== "Wayfinder")
                .map((workplace) => (
                  <GroupWorkspaceTreeLevel
                    item={workplace}
                    toggleParent={() => {}}
                    key={`${workplace.id}-tree-root`}
                    formik={formik}
                    allToggled={allToggled}
                  />
                ));
            })}
          </>
        );
      }}
    </WorkspacePicker>
  );
};
